import { useState } from 'react';
import { Button, Typography } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Discord from '../assets/discord.svg';
import Telegram from '../assets/telegram.svg';
import EditChannelPopup from './EditChannelPopup';

const ChannelList = ({ 
  channels, 
  step, 
  removeChannel, 
  isSettings = false,
  onChannelUpdate = () => {}
}) => {
  const [editingChannel, setEditingChannel] = useState(null);

  const handleEditSuccess = () => {
    onChannelUpdate();
    setEditingChannel(null);
  };
  
  return (
    <>
      <div className="flex flex-col gap-2">
        {channels.map((channel, index) => (
          <div key={index} className="bg-[#F9FAFB] border border-[#D0D5DD] p-2 rounded-md flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img
                src={step === "discord" ? Discord : Telegram}
                alt="Platform"
                className="h-3"
              />
              <div className="flex flex-col items-start">
                <Typography.Text strong>{channel.channelName}</Typography.Text>
                <Typography.Text style={{ fontSize: "12px", color: "gray" }}>
                  #ID {channel.channelID}
                </Typography.Text>
              </div>
            </div>
            <div className="flex">
              {isSettings && (
                <Button
                  type="text"
                  icon={<EditOutlined />}
                  onClick={() => setEditingChannel(channel)}
                />
              )}
              <Button
                type="text"
                icon={<DeleteOutlined />}
                onClick={() => removeChannel(index)}
                danger
              />
            </div>
          </div>
        ))}
      </div>

      <EditChannelPopup 
        channelData={editingChannel}
        onClose={() => setEditingChannel(null)}
        onUpdateSuccess={handleEditSuccess}
        visible={!!editingChannel}
      />
    </>
  );
};

export default ChannelList;